<template>  
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-6 mb-12">
    <div class="flex flex-col md:flex-row -mx-4">
        <div class="md:flex-1 px-4  ">
          <!--<div class="relative w-full h-96 py-4 ">
          <transition :name="transitionName"  mode="out-in">  
            <img  v-if="mainImg.image"  @click="openModal(mainImg)"  class="absolute inset-0 w-full h-full object-contain rounded-lg bg-gray-100 transition-opacity  transition-opacity duration-500" :src="mainImg.image"  :key="mainImg.item" alt="Imagen">
          </transition>
        </div>
          <div class="flex -mx-2 mb-4 mt-4">
              <div v-for="(prod, index) in product.images" :key="index" class="flex-1 px-2" @click="mainImg = prod"  :class="{ 'ring-2 ring-indigo-300 ring-inset': prod.item === mainImg.item }" >
                <img :src="prod.image" alt="" class="w-full">
              </div>
              
          </div>-->

          <div class="grid grid-cols-2">
            <div v-for="(prod, index) in product.images" :key="index"   :class="{ 'ring-2 ring-indigo-300 ring-inset': prod.item === mainImg.item }"  @click="openModal(prod)">
                <img :src="prod.image" alt="" class="w-full">
              </div>
              
          </div>
        </div>
        <div class="md:flex-1 px-4">
            <h2 class="mb-2 leading-tight tracking-tight font-bold text-gray-800 text-2xl md:text-3xl">{{product.name}}</h2>

            <div class="flex items-center space-x-4 my-4">
          <div>
            <div class="rounded-lg flex py-2 px-3">
              <span class="text-red-400 font-bold mr-1 mt-1">S/.</span>
              <span class="font-bold text-red-600 text-3xl">{{product.price.toFixed(2)}}</span>
            </div>
          </div>
          <div class="flex-1">
            <p class="text-gray-500 text-xl   line-through font-semibold" v-if="product.price_original">S/. {{product.price_original.toFixed(2)}}</p>
           
          </div>
        </div>
          <p class="text-xl font-bold mb-4">Color</p>
          <div class="flex items-center gap-x-3 mb-4">
            <label x-radio-group-option="" aria-label="White" class="relative -m-0.5 flex cursor-pointer items-center justify-center rounded-full p-0.5 focus:outline-hidden ring-gray-400 undefined" x-description="Active and Checked: &quot;ring-3 ring-offset-1&quot;" >
              <input type="radio" x-model="value" name="color-choice" value="White" class="sr-only">
                <span aria-hidden="true" class="size-8 bg-white rounded-full border border-black"></span>
            </label>
          </div>  
          <p class="text-xl font-bold mb-4">Tallas Disponibles</p>
          <div class="flex flex-wrap gap-4">
            <div class="flex items-center justify-center w-28 h-28 border-2 border-gray-300 rounded-lg bg-gray-100 hover:bg-gray-200">
              <h2 class="text-3xl font-bold text-gray-700">M</h2>
            </div>
            <div class="flex items-center justify-center w-28 h-28 border-2 border-gray-300 rounded-lg bg-gray-100 hover:bg-gray-200">
              <h2 class="text-3xl font-bold text-gray-700">L</h2>
            </div>
          </div>
          <div class="flex py-4 space-x-4">
            <a :href="product.wsp" target="_blank" type="button" class="h-14 px-6 py-2 flex gap-4 font-semibold rounded-xl bg-green-600 hover:bg-green-500 text-white items-center">
            <span class="text-2xl">Lo Quiero</span>
            <svg width="32" height="32" viewBox="-2.73 0 1225.016 1225.016" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><path fill="#E0E0E0" d="M1041.858 178.02C927.206 63.289 774.753.07 612.325 0 277.617 0 5.232 272.298 5.098 606.991c-.039 106.986 27.915 211.42 81.048 303.476L0 1225.016l321.898-84.406c88.689 48.368 188.547 73.855 290.166 73.896h.258.003c334.654 0 607.08-272.346 607.222-607.023.056-162.208-63.052-314.724-177.689-429.463zm-429.533 933.963h-.197c-90.578-.048-179.402-24.366-256.878-70.339l-18.438-10.93-191.021 50.083 51-186.176-12.013-19.087c-50.525-80.336-77.198-173.175-77.16-268.504.111-278.186 226.507-504.503 504.898-504.503 134.812.056 261.519 52.604 356.814 147.965 95.289 95.36 147.728 222.128 147.688 356.948-.118 278.195-226.522 504.543-504.693 504.543z"/><linearGradient id="a" gradientUnits="userSpaceOnUse" x1="609.77" y1="1190.114" x2="609.77" y2="21.084"><stop offset="0" stop-color="#20b038"/><stop offset="1" stop-color="#60d66a"/></linearGradient><path fill="url(#a)" d="M27.875 1190.114l82.211-300.18c-50.719-87.852-77.391-187.523-77.359-289.602.133-319.398 260.078-579.25 579.469-579.25 155.016.07 300.508 60.398 409.898 169.891 109.414 109.492 169.633 255.031 169.57 409.812-.133 319.406-260.094 579.281-579.445 579.281-.023 0 .016 0 0 0h-.258c-96.977-.031-192.266-24.375-276.898-70.5l-307.188 80.548z"/><image overflow="visible" opacity=".08" width="682" height="639" xlink:href="FCC0802E2AF8A915.png" transform="translate(270.984 291.372)"/><path fill-rule="evenodd" clip-rule="evenodd" fill="#FFF" d="M462.273 349.294c-11.234-24.977-23.062-25.477-33.75-25.914-8.742-.375-18.75-.352-28.742-.352-10 0-26.25 3.758-39.992 18.766-13.75 15.008-52.5 51.289-52.5 125.078 0 73.797 53.75 145.102 61.242 155.117 7.5 10 103.758 166.266 256.203 226.383 126.695 49.961 152.477 40.023 179.977 37.523s88.734-36.273 101.234-71.297c12.5-35.016 12.5-65.031 8.75-71.305-3.75-6.25-13.75-10-28.75-17.5s-88.734-43.789-102.484-48.789-23.75-7.5-33.75 7.516c-10 15-38.727 48.773-47.477 58.773-8.75 10.023-17.5 11.273-32.5 3.773-15-7.523-63.305-23.344-120.609-74.438-44.586-39.75-74.688-88.844-83.438-103.859-8.75-15-.938-23.125 6.586-30.602 6.734-6.719 15-17.508 22.5-26.266 7.484-8.758 9.984-15.008 14.984-25.008 5-10.016 2.5-18.773-1.25-26.273s-32.898-81.67-46.234-111.326z"/><path fill="#FFF" d="M1036.898 176.091C923.562 62.677 772.859.185 612.297.114 281.43.114 12.172 269.286 12.039 600.137 12 705.896 39.633 809.13 92.156 900.13L7 1211.067l318.203-83.438c87.672 47.812 186.383 73.008 286.836 73.047h.255.003c330.812 0 600.109-269.219 600.25-600.055.055-160.343-62.328-311.108-175.649-424.53zm-424.601 923.242h-.195c-89.539-.047-177.344-24.086-253.93-69.531l-18.227-10.805-188.828 49.508 50.414-184.039-11.875-18.867c-49.945-79.414-76.312-171.188-76.273-265.422.109-274.992 223.906-498.711 499.102-498.711 133.266.055 258.516 52 352.719 146.266 94.195 94.266 146.031 219.578 145.992 352.852-.118 274.999-223.923 498.749-498.899 498.749z"/></svg>
            </a>
          </div>
            <!-- Especificaciones técnicas -->
            <div class="p-4 border-2 border-gray-300 rounded-lg bg-gray-100">
              <h3 class="text-xl font-bold text-gray-700">Especificaciones Técnicas</h3>
              <ul class="text-sm text-gray-600 mt-2">
                <li>100% poliéster</li>
                <li>Impermeable</li>
                <li>Personalizable</li>
              </ul>
            </div>

            <!-- Cuidados sugeridos -->
            <div class="mt-4 p-4 border-2 border-gray-300 rounded-lg bg-gray-100">
              <h3 class="text-xl font-bold text-gray-700">Cuidados Sugeridos</h3>
              <ul class="text-sm text-gray-600 mt-2">
                <li>No usar cloro</li>
                <li>No remojar en detergente</li>
                <li>No planchar en caliente</li>
              </ul>
            </div>
        </div>
    </div>
    <div v-if="showModal" class="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"  @click.self="closeModal">
      <div class="relative">
        <button 
          class="absolute top-2 right-2 text-white text-2xl" 
          @click="closeModal">&times;</button>
        <img 
          :src="modalImage.image" 
          alt="Zoomed Image" 
          class="max-w-screen-md max-h-screen object-contain cursor-zoom-in" 
          @click="toggleZoom"
          :class="{ 'scale-150': isZoomed }"
        />
      </div>
    </div>
</div>
</template>
<script>
import image1 from '@/assets/uniform/1.jpg';
import image2 from '@/assets/uniform/2.jpg';
import image3 from '@/assets/uniform/3.jpg';
import image4 from '@/assets/uniform/4.jpg';
import image5 from '@/assets/uniform/5.jpg';
import image6 from '@/assets/uniform/6.jpg';
import image7 from '@/assets/uniform/7.jpg';
import faker from '@/assets/uniform/faker.jpg';
import zeus from '@/assets/uniform/zeus.jpg';


  export default {
    name: 'ProductDetails',
    data() {
      return {
        product: null, 
        mainImg: null,
        transitionName: 'fade-slow',
        modalImage: {}, // Imagen en el modal
        showModal: false, // Controla si el modal está abierto
        isZoomed: false, // Controla el estado de zoom
        products: [
        { name: '2024 T1 Worlds Uniform Jacket',uri: '2024-t1-worlds-uniform-jacket',
         description:  `<p class="text-xl font-bold">Uniforme T1 Worlds 2024 <p>`, 
          price: 159.00,
          price_original: 200.00, 
          wsp: 'https://wa.me/p/8887934564630233/51949234215',
          images:[
            {image: image1, item: 1},
            {image: image2, item: 2},
            {image: image5, item: 3},
            {image: image6, item: 4}
          ] },
        { 
          name: '2024 T1 Worlds Uniform Jersey',uri:'2024-t1-worlds-uniform-jersey',
          description: '<p class="text-xl font-bold">Uniforme T1 Worlds 2024 <p>', 
          price: 89.00, price_original: 120.00, 
          wsp: 'https://wa.me/p/8990774967705129/51949234215',
          images:[
            {image: image3, item: 1},
            {image: image4, item: 2},
            {image: faker, item: 3},
            {image: zeus, item: 4},
          ]  },
        { 
          name: 'Pack Uniform Jacket and Jersey',uri: 'pack-uniform-jacket-jersey', 
          description: 'Blue',
          price: 220.00,
         wsp: 'https://wa.me/p/8876380359074766/51949234215',
         price_original: null, 
         images:[
            {image: image2, item: 1},
            {image: image3, item: 2},
            {image: image4, item: 3},
            {image: image7, item: 4},
          ] },
      ],
        productName: this.$route.params.name, // Accede al parámetro 'name'
      };
    },
    watch: {
      // Observa cambios en la ruta dinámica
      '$route.params.name'(newName) {
        this.productName = newName;
      },
    },
    methods: {
      findProductByName(name) {
        return this.products.find((product) => product.uri === name);
      },
      openModal(image) {
        this.modalImage = image;
        this.showModal = true;
        this.isZoomed = false; // Resetea el zoom al abrir el modal
      },
      closeModal() {
        this.showModal = false;
      },
      toggleZoom() {
        this.isZoomed = !this.isZoomed; // Alterna entre zoom y no zoom
      },
    },
    created() { // Obtener el parámetro dinámico 'name'
      this.product = this.findProductByName(this.productName); // Buscar el producto
      this.mainImg = this.product.images[0];
    },


  };
</script>
<style scoped>
.fade-slow-enter-active, .fade-slow-leave-active {
  transition: opacity 1s ease-in-out; /* Duración de 1 segundo para un cambio suave */
}
.fade-slow-enter, .fade-slow-leave-to /* .fade-slow-leave-active en versiones <2.1.8 */ {
  opacity: 0;
}
.fade-slow-enter-to, .fade-slow-leave {
  opacity: 1;
}
.scale-150 {
  transform: scale(1.5);
  transition: transform 0.3s ease;
}
</style>